export default function toSnakeCase(input) {
	// Validation
	if (typeof input !== 'string' && typeof input !== 'number') return ''

	// Convert input to string to handle non-string inputs gracefully
	input = String(input ?? '')

	// Replace camelCase or PascalCase with spaces
	input = input.replace(/([a-z])([A-Z])/g, '$1 $2')

	// Replace spaces, hyphens, and underscores with a space
	input = input.replace(/[-_\s]+/g, ' ')

	// Convert to lowercase
	input = input.toLowerCase()

	// Replace spaces with underscores
	input = input.replace(/\s+/g, '_')

	return input
}
